import { Accordion, AccordionActions, AccordionDetails, AccordionSummary, Box, Button, TextField } from '@material-ui/core';
import { Delete, ExpandLess, ExpandMore, UnfoldMore } from '@material-ui/icons';
import { useEffect, useState } from 'react';

export const UrlControl = ({ onUpdate, value, onDelete, isSelected }) => {
    const [title, setTitle] = useState("");
    const [subTitle, setSubTitle] = useState("");
    const [link, setLink] = useState("");
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        let val = JSON.parse(value);
        setSubTitle(val.subTitle);
        setTitle(val.title);
        setLink(val.link);
    }, [value]);

    useEffect(() => {
        setExpanded(isSelected);
    }, [isSelected])

    return (
        <div className='w-full'>
            <Accordion variant='outlined' expanded={expanded}>
                <AccordionSummary
                    className='handle'
                    expandIcon={
                        expanded ?
                            <ExpandLess onClick={() => setExpanded(!expanded)} /> :
                            <ExpandMore onClick={() => setExpanded(!expanded)} />
                    }
                    aria-label="Expand"
                    aria-controls="additional-actions1-content"
                    id="additional-actions1-header"
                    style={{ padding: "0 5px" }}
                >
                    <Box display="flex" alignItems="center" width={"100%"}>
                        <Box display="flex" alignItems="center">
                            <UnfoldMore htmlColor='#CECECE' />&nbsp;


                            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.05098 5.79941C6.06492 5.96735 5.13052 6.35488 4.3253 6.92758C3.87748 7.24622 3.17992 7.94378 2.86128 8.39161C2.35317 9.10209 1.95702 10.015 1.76756 10.902C1.6556 11.4273 1.6556 12.9215 1.76756 13.4425C2.34456 16.1294 4.48032 18.1532 7.16724 18.5451C7.53325 18.5967 7.92079 18.6097 8.95422 18.6011L10.2718 18.5881L10.4613 18.459C11.0426 18.0456 10.9909 17.1629 10.3623 16.8442C10.2116 16.7667 10.1082 16.7581 9.23841 16.7581C7.57631 16.7581 6.98209 16.6677 6.20701 16.306C5.70752 16.0735 5.34151 15.828 4.96689 15.4706C3.49856 14.0712 3.11533 11.9182 4.01528 10.1269C4.5406 9.08487 5.53959 8.21075 6.61608 7.84475C7.22322 7.64237 7.44283 7.61653 8.88963 7.5907L10.2718 7.56486L10.4613 7.43568C11.0426 7.02231 10.9909 6.13958 10.3623 5.82094C10.2073 5.73913 10.1125 5.73482 8.78629 5.73913C7.85189 5.74343 7.26628 5.76066 7.05098 5.79941Z" fill="#CECECE" />
                                <path d="M15.0389 5.80347C14.3887 6.15656 14.3284 7.01345 14.9226 7.43544L15.1121 7.56462L16.5158 7.59045C17.9798 7.62059 18.1607 7.64212 18.7592 7.8445C19.8443 8.21051 20.839 9.08032 21.3686 10.1267C22.4968 12.3744 21.571 15.1173 19.3018 16.2498C18.5052 16.6502 18.1305 16.7148 16.5029 16.7449C15.3317 16.7665 15.1508 16.7794 15.013 16.8483C14.3887 17.1626 14.3413 18.0453 14.9226 18.4587L15.1121 18.5879H16.6234C18.0272 18.5836 18.1693 18.5793 18.5784 18.4889C21.149 17.9291 23.048 16.0258 23.612 13.4423C23.7283 12.9212 23.7283 11.4314 23.6163 10.9017C23.4269 10.0147 23.0307 9.10184 22.5226 8.39136C22.204 7.94354 21.5064 7.24597 21.0586 6.92733C20.3653 6.43645 19.474 6.0403 18.5913 5.83792C18.109 5.73027 15.2326 5.70013 15.0389 5.80347Z" fill="#CECECE" />
                                <path d="M9.52714 11.3193C8.87693 11.6595 8.81665 12.525 9.41087 12.947L9.60034 13.0762H12.692H15.7837L15.9732 12.947C16.5545 12.5336 16.5028 11.6509 15.8741 11.3323C15.7148 11.2504 15.6115 11.2461 12.6834 11.2461C10.0137 11.2504 9.63909 11.2591 9.52714 11.3193Z" fill="#CECECE" />
                            </svg>

                        </Box>
                        <div className='pl-2 text-gray-500'>
                            Insert Url
                        </div>
                    </Box>
                </AccordionSummary>
                <AccordionDetails>
                    <div className='w-full'>
                        <TextField
                            placeholder='Label'
                            label="Label"
                            onChange={(e) => {
                                setTitle(e.target.value)
                                onUpdate(
                                    JSON.stringify({
                                        title: e.target.value,
                                        subTitle: subTitle,
                                        link: link
                                    }));
                            }}
                            variant='outlined'
                            type={"link"}
                            margin="dense"
                            fullWidth
                            className='my-2'
                            value={title}
                        />
                        <TextField
                            placeholder='Title'
                            label="Title"
                            onChange={(e) => {
                                setSubTitle(e.target.value)
                                onUpdate(
                                    JSON.stringify({
                                        title: title,
                                        subTitle: e.target.value,
                                        link: link
                                    }));
                            }}
                            variant='outlined'
                            margin="dense"
                            fullWidth
                            className='my-2'
                            value={subTitle}
                        />
                        <TextField
                            label='Hyperlink'
                            placeholder='Hyperlink'
                            onChange={(e) => {
                                setLink(e.target.value)
                                onUpdate(
                                    JSON.stringify({
                                        title: title,
                                        subTitle: subTitle,
                                        link: e.target.value
                                    }));
                            }}
                            variant='outlined'
                            type={"link"}
                            margin="dense"
                            fullWidth
                            className='my-2'
                            value={link}
                        />
                    </div>
                </AccordionDetails>
                <AccordionActions>
                    <Button
                        className="ml-0"
                        startIcon={<Delete />}
                        onClick={() => {
                            setExpanded(false);
                            setTitle("");
                            setSubTitle("");
                            setLink("");
                            onDelete();
                        }} fullWidth
                        variant='contained' color="default">
                        Remove
                    </Button>
                </AccordionActions>
            </Accordion>
        </div>
    )
}
